export default __webpack_public_path__ + "cf0e14e30c38c8d95a0e7e515826bbb4.png";